import React, { FC } from "react";
import { Worker } from "../../../../types";
import { Box, IconButton, useTheme } from "@mui/material";
import classes from "./EditWorkersMain.module.scss";

//削除
import DeleteIcon from "@mui/icons-material/Delete";

type Props = {
  workerList: Array<Worker>;
  setWorkerList: React.Dispatch<React.SetStateAction<Worker[]>>;
};

const EditWorkersMain: FC<Props> = (props) => {
  const { workerList, setWorkerList } = props;
  const theme = useTheme();
  const handleDeleteButtonClick = (workerId: string) => {
    setWorkerList((prevState) =>
      prevState.filter((worker) => worker.workerId !== workerId)
    );
  };

  return (
    <div className={classes.rootContainer}>
      {workerList.map((worker) => (
        <div className={classes.workerContainer} key={worker.workerId}>
          <div className={classes.workerId}>{worker.workerId}</div>
          <div className={classes.workerContents}>
            <div className={classes.workerName}>{worker.workerName}</div>
            <div className={classes.deleteButton}>
              <IconButton
                component="label"
                disabled={false}
                onClick={() =>
                  handleDeleteButtonClick(worker.workerId as string)
                }
                sx={{
                  color: "#cccccc",
                  height: 12,
                  width: 12,
                }}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EditWorkersMain;
